import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import captainTCCardImg from '../../images/captain-tc/captain-tc-card.jpeg';
import './CaptainTCCards.css';

const CaptainTCCards = () => {
    return (
        <Fragment>
            <div className='index_ico page_wrapper'>
                <Header />
                <main className="page_content">
                    <PageTitle pageTitle={'Captain TC Cards'} pagesub={'Home'} />
                    <div className="captain-tc-cards-page">
                        {/* Hero Card Image */}
                        <section className="captain-tc-hero">
                            <div className="captain-tc-card-image-wrapper">
                                <img
                                    src={captainTCCardImg}
                                    alt="Captain TC Card - TopCoin Collectible Series Founder Edition"
                                    loading="lazy"
                                />
                            </div>
                        </section>

                        {/* Content */}
                        <div className="captain-tc-content">
                            {/* Intro */}
                            <div className="captain-tc-section captain-tc-intro-section">
                                <p className="captain-tc-intro-text">
                                    With a Captain TC Card your TopCoin grows <span className="gold-highlight">ten times faster</span>—so
                                    you reach every reward and cash-out milestone much sooner than without the card.
                                </p>
                                <p className="captain-tc-intro-subtext">
                                    Buy one card and unlock <span className="gold-highlight">five exclusive benefits</span>:
                                </p>
                            </div>

                            {/* Benefit 1 – Purchase Reward */}
                            <div className="captain-tc-benefit-card">
                                <div className="benefit-number">1</div>
                                <div className="benefit-body">
                                    <h3 className="benefit-title">Purchase Reward</h3>
                                    <p className="benefit-description">
                                        Receive an instant TopCoin credit the moment you buy the card.
                                    </p>
                                </div>
                            </div>

                            {/* Benefit 2 – Reward Card Promotion */}
                            <div className="captain-tc-benefit-card">
                                <div className="benefit-number">2</div>
                                <div className="benefit-body">
                                    <h3 className="benefit-title">Reward Card Promotion</h3>
                                    <p className="benefit-description">
                                        Receive TopCoin rewards when you buy the card. Opens when you reach{' '}
                                        <span className="gold-highlight">5,000 TopCoin</span> in your Extra Card Promotion.
                                    </p>
                                </div>
                            </div>

                            {/* Benefit 3 – Extra Card Promotion */}
                            <div className="captain-tc-benefit-card">
                                <div className="benefit-number">3</div>
                                <div className="benefit-body">
                                    <h3 className="benefit-title">Extra Card Promotion</h3>
                                    <p className="benefit-description">
                                        Every TopCoin collected in your main wallet is matched{' '}
                                        <span className="gold-highlight">1-for-1</span> and added to your Extra Card balance.
                                    </p>
                                </div>
                            </div>

                            {/* Benefit 4 – Bonus Card Promotion */}
                            <div className="captain-tc-benefit-card">
                                <div className="benefit-number">4</div>
                                <div className="benefit-body">
                                    <h3 className="benefit-title">Bonus Card Promotion</h3>
                                    <p className="benefit-description">
                                        Every TopCoin in your Extra Card balance is multiplied by{' '}
                                        <span className="gold-highlight">16</span> and credited to your Bonus Card
                                        balance—super-charging your earnings. This wallet opens when you reach{' '}
                                        <span className="gold-highlight">1,000 TopCoin</span> in your Extra Card Promotion.
                                    </p>
                                </div>
                            </div>

                            {/* Benefit 5 – Cash Wallet */}
                            <div className="captain-tc-benefit-card captain-tc-benefit-card--featured">
                                <div className="benefit-number">5</div>
                                <div className="benefit-body">
                                    <h3 className="benefit-title">Cash Wallet</h3>

                                    <div className="cash-wallet-detail">
                                        <h4 className="cash-wallet-label">What it is</h4>
                                        <p className="benefit-description">
                                            A single reward fund managed by TopCoin UK for everyone who owns a Captain TC
                                            Cash-Back Card. The money inside the wallet comes from purchases made with
                                            participating merchants.
                                        </p>
                                    </div>

                                    <div className="cash-wallet-detail">
                                        <h4 className="cash-wallet-label">When it opens for you</h4>
                                        <p className="benefit-description">
                                            Each time you earn Extra-Promotion TopCoin, your personal share of the Cash
                                            Wallet grows. Once your Extra-Promotion balance reaches{' '}
                                            <span className="gold-highlight">5,000 TopCoin</span>, your share unlocks and
                                            becomes available.
                                        </p>
                                    </div>

                                    <div className="cash-wallet-detail">
                                        <h4 className="cash-wallet-label">How withdrawal works</h4>
                                        <p className="benefit-description">
                                            After you reach the 5,000-coin trigger, you can withdraw your share whenever
                                            you like. A small <span className="gold-highlight">2% processing fee</span>{' '}
                                            covers payment-service costs; payouts are handled by an FCA-authorised
                                            provider.
                                        </p>
                                    </div>

                                    <p className="benefit-description cash-wallet-note">
                                        Your Cash Wallet share unlocks each time you accumulate{' '}
                                        <span className="gold-highlight">5,000 TopCoin</span> in your Extra Card Promotion.
                                    </p>
                                </div>
                            </div>

                            <hr className="captain-tc-divider" />

                            {/* Cooling-Off Period */}
                            <div className="captain-tc-section captain-tc-cooling-section">
                                <h2 className="captain-tc-section-title">
                                    <span className="title-icon">🛡️</span>
                                    Cooling-Off Period
                                </h2>
                                <p className="captain-tc-text">
                                    You can cancel within <span className="gold-highlight">14 days</span> for a full refund
                                    if you have not used the card.
                                </p>
                            </div>

                            {/* Full T&Cs */}
                            <div className="captain-tc-section captain-tc-terms-section">
                                <h2 className="captain-tc-section-title">
                                    <span className="title-icon">📋</span>
                                    Full Terms &amp; Conditions
                                </h2>
                                <p className="captain-tc-text">
                                    See our full <a href="/captain-tc-cashback-card-terms">Terms &amp; Conditions</a> for details. Read our Full Terms &amp; Conditions for details on expiry, refunds, data use, and all programme rules.
                                </p>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    );
};

export default CaptainTCCards;
